import React, { useEffect, useRef, useState } from "react";
import {
    View,
} from "react-native";

import { globalFontStyle, globalStyle } from "../assets";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { globalConfigurableData } from "../utils/globalConstant";
import { isMobile } from "../utils/commonMethods";
import width from "../assets/Width";
import FormTextLabel from "./FormTextLabel";
import FastImage from "../common/FastImage";

const PartnerError = ({
  route,
}) => {
    const message = route?.params?.message;
    const insets = useSafeAreaInsets();


    return (
        <View
            style={[
                {
                    paddingTop: insets.top,
                    paddingLeft: insets.left,
                    paddingRight: insets.right,
                },
                isMobile() ? globalStyle.scroll_webFix : {},
            ]}
        >
            <View style={[globalStyle.headerContainer]}>
                <FastImage
                    style={{
                        height: 55,
                        width: 130,
                    }}
                    source={globalConfigurableData?.logoUrl()}
                />
            </View>
            <View style={{
                height: width.height-81,
                justifyContent: 'center',
                alignItems: 'center',
                paddingHorizontal: 20
            }}>
                <FormTextLabel
                    labelStyles={{
                        ...globalFontStyle.appFontHeading,
                        color: globalConfigurableData.primaryTextColor1,
                        textAlign: 'center'
                    }}
                    label={message} />
            </View>
        </View>
    );
};

export default PartnerError;
